// extracted by mini-css-extract-plugin
module.exports = {"OnePictureEu":"OnePicture_OnePictureEu__xu0Yh"};